import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "title"]

import useWishlist from '@/shared/product/wishlist/useWishlist';
import { computed } from 'vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistButton',
  props: {
    sku: null,
    name: null
  },
  setup(__props: any) {

const props = __props as {
    sku: string,
    name?: string,
}



const { addToWishListButton } = useGlobalLabels(GlobalLabels.wishlist);
const { setActive, getIsInLists } = useWishlist();
const iconName = computed(() => getIsInLists(props.sku) ? 'icon-heart-fill' : 'icon-heart');

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "aria-label": _unref(addToWishListButton),
    title: _unref(addToWishListButton),
    class: "outline-none focus:outline-none",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setActive)(__props.sku, __props.name)))
  }, [
    _createVNode(_component_c_icon, {
      name: _unref(iconName),
      class: "h-20"
    }, null, 8, ["name"])
  ], 8, _hoisted_1))
}
}

})